import { isLoggedInUser } from "@/dynamic.routes";
import store from "@/store";

export default [{
    path: "/",
    name: "root",
    //@ts-ignore
    beforeEnter: (to, from, next) => {
      const isLoggedIn = !!store.state.user;
      if (to.path === "/") {
        if (isLoggedIn) {
          return next("/panel-facto/estadisticas");
        } else {
          return next("/login");
        }
      } else {
        return next();
      }
    }
  },{
    path: "/login",
    name: "newlogin",
    component: () => import("@/views/NewLogin.vue"),
    beforeEnter: isLoggedInUser
  },{
    path: "/contacto",
    name: "contact",
    component: () => import("@/views/Contact.vue")
  },{
    path: "/registrar",
    name: "register",
    component: () => import("@/views/Register.vue"),
    props: true,
    beforeEnter: isLoggedInUser
  },{
    path: "/registro",
    name: "register-requests",
    component: () => import("@/views/Register.vue"),
    beforeEnter: isLoggedInUser
  },{
    path: "/recuperar",
    name: "recuperar",
    component: () => import("@/views/Recover.vue"),
    beforeEnter: isLoggedInUser
  },{
    path: "/recuperar/:token",
    name: "recuperar contraseña",
    component: () => import("@/views/NewPassword.vue"),
    props: true,
    beforeEnter: isLoggedInUser
  },
  {
    path: "/test",
    name: "test",
    component: () => import("@/views/Test.vue"),
    beforeEnter: isLoggedInUser
  }
]